(() => {
    const elements = document.querySelectorAll('[js-dynamic-country]');
    if (!elements.length) return;
  
    const formatCountryKey = (name) => {
      return name.trim().toLowerCase().replace(/\s+/g, '-');
    };
  
    const getGeo = async () => {
      try {
        const response = await fetch('https://ipwho.is/');
        const data = await response.json();
        console.log('Geo response:', data);
        return data;
      } catch (e) {
        console.warn('Geo lookup failed', e);
        return null;
      }
    };
  
    const updateElement = async (el) => {
      el.setAttribute('state', 'loading');
  
      const geo = await getGeo();
      const countryName = geo?.country;
      const key = countryName ? formatCountryKey(countryName) : null;
  
      const days = key && el.getAttribute(`data-country-${key}`);
  
      if (!days) {
        const fallbackHTML = el.querySelector('.delivery-fallback')?.innerHTML || '';
        el.innerHTML = fallbackHTML;
        el.setAttribute('state', 'ready');
        return;
      }
  
      const templateHTML = el.querySelector('.delivery-template')?.innerHTML || '';
      const resultHTML = templateHTML
        .replaceAll('[[ country ]]', countryName)
        .replaceAll('[[ days ]]', `<strong>${days}</strong>`);
  
      el.innerHTML = resultHTML;
      el.setAttribute('state', 'ready');
    };
  
    elements.forEach(updateElement);
  })();
  